import {
  BLOCKED_NAVIGATION_IFRAME_NAME_PREFIX,
  EXTERNAL_NAVIGATION_IFRAME_NAME_PREFIX,
  SAME_ORIGIN_NAVIGATION_IFRAME_NAME_PREFIX,
} from '@electron/shared/constants';
import { type ComponentPropsWithRef, useId } from 'react';

const FRAME_NAME_PREFIX = {
  block: BLOCKED_NAVIGATION_IFRAME_NAME_PREFIX,
  external: EXTERNAL_NAVIGATION_IFRAME_NAME_PREFIX,
  'same-origin': SAME_ORIGIN_NAVIGATION_IFRAME_NAME_PREFIX,
} as const;

interface IframeProps extends ComponentPropsWithRef<'iframe'> {
  navigation?: keyof typeof FRAME_NAME_PREFIX;
}

export const Iframe = ({
  name,
  navigation = 'block',
  ...props
}: IframeProps) => {
  const id = useId();

  return (
    <iframe {...props} name={`${FRAME_NAME_PREFIX[navigation]}${name ?? id}`} />
  );
};
